import invokeMap from 'lodash/invokeMap';
import isFunction from 'lodash/isFunction';
import map from 'lodash/map';
import Rollbar from 'rollbar';

import packageConfig from '../../package.json';

const ROLLBAR_IGNORE_MESSAGES = [
  'Cannot read property of undefined/null expression startOrder',
  'PaymentRequest is not defined',
  'Timeout',
  'Script error.',
];

const getOutputs = () => {
  const isServerSide = typeof window === 'undefined';

  // Storybook & Tests
  if (!process.env.rollbar || !process.env.rollbar.accessToken) {
    return [console];
  }

  // @NOTE: do not use lodash get here as it does not work when target is serverless
  const accessToken = !isServerSide ? process.env.rollbar.accessToken.client : process.env.rollbar.accessToken.server;

  // Temp fix as nps pulls in the as part of the components so ignore so we don't add rollbar twice
  if (!accessToken) {
    return [console];
  }

  const client = new Rollbar({
    accessToken,
    captureUncaught: true,
    captureUnhandledRejections: true,
    environment: process.env.rollbar.environment || 'development',
    reportLevel: 'warning',
    ignoredMessages: ROLLBAR_IGNORE_MESSAGES,
    payload: {
      client: {
        javascript: {
          code_version: process.env.rollbar.codeVersion || packageConfig.version,
          guess_uncaught_frames: true,
        },
      },
    },
  });

  if (!isServerSide && process.env.web.environment === 'production') {
    return [client];
  }

  return [console, client];
};

const outputs = getOutputs();
const logger = {
  setPerson: id =>
    map(outputs, output => {
      if (isFunction(output.configure)) {
        output.configure({ payload: { person: { id } } });
      }
    }),
  clearPerson: () =>
    map(outputs, output => {
      if (isFunction(output.configure)) {
        output.configure({ payload: { person: { id: null } } });
      }
    }),
  error: (...args) => invokeMap(outputs, 'error', ...args),
  warn: (...args) => invokeMap(outputs, 'warn', ...args),
  info: (...args) => invokeMap(outputs, 'info', ...args),
};

export { getOutputs, logger };
